import { ActionType, getType } from 'typesafe-actions';

import * as usersActions from './actions';
import {
  AllUsersTypes,
  PendingApprovalTypes,
  UserReviewersTypes,
} from './types';

type UsersActionType = ActionType<typeof usersActions>;

export interface UsersState {
  users: {
    data: AllUsersTypes[];
    loading: boolean;
  };
  pendingApprovals: {
    data: PendingApprovalTypes[];
    loading: boolean;
  };
  userReviewers: {
    data: UserReviewersTypes[];
    loading: boolean;
  };
}

const initialState: UsersState = {
  users: {
    data: [],
    loading: false,
  },
  pendingApprovals: {
    data: [],
    loading: false,
  },
  userReviewers: {
    data: [],
    loading: false,
  },
};

const usersReducer = (
  state: UsersState = initialState,
  action: UsersActionType,
): UsersState => {
  switch (action.type) {
    //all users
    case getType(usersActions.getAllUser.request):
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    case getType(usersActions.getAllUser.success):
      return {
        ...state,
        users: {
          ...state.users,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(usersActions.getAllUser.failure):
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
        },
      };

    //Pending Approval Users
    case getType(usersActions.getPendingApproval.request):
      return {
        ...state,
        pendingApprovals: {
          ...state.pendingApprovals,
          loading: true,
        },
      };
    case getType(usersActions.getPendingApproval.success):
      return {
        ...state,
        pendingApprovals: {
          ...state.users,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(usersActions.getPendingApproval.failure):
      return {
        ...state,
        pendingApprovals: {
          ...state.pendingApprovals,
          loading: false,
        },
      };

    //User Reviewers
    case getType(usersActions.getUserReviewer.request):
      return {
        ...state,
        userReviewers: {
          ...state.userReviewers,
          loading: true,
        },
      };
    case getType(usersActions.getUserReviewer.success):
      return {
        ...state,
        userReviewers: {
          ...state.users,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(usersActions.getUserReviewer.failure):
      return {
        ...state,
        userReviewers: {
          ...state.userReviewers,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default usersReducer;
